import Star from "@mui/icons-material/Star";
import { Chip } from "@mui/material";
import React from "react";

interface StarredFilterChipProps {
  active: boolean;
  onClick: () => void;
}

/** "Starred" quick-filter chip for a DataTable's starred-only view; pair with useTableStarring. */
function StarredFilterChip({ active, onClick }: StarredFilterChipProps) {
  return (
    <Chip
      label="Starred"
      icon={<Star fontSize="small" />}
      clickable
      variant="filled"
      color={active ? "primary" : "default"}
      onClick={onClick}
      sx={{ fontSize: "0.75rem" }}
    />
  );
}

export default StarredFilterChip;
